import { render, staticRenderFns } from "./ParticipantsCourseoutcomesScore.vue?vue&type=template&id=1aa3fdd8"
import script from "./ParticipantsCourseoutcomesScore.vue?vue&type=script&lang=js"
export * from "./ParticipantsCourseoutcomesScore.vue?vue&type=script&lang=js"
import style0 from "./ParticipantsCourseoutcomesScore.vue?vue&type=style&index=0&id=1aa3fdd8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports